import React, { useState, useEffect } from "react";
import Box from "@mui/system/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./styles/Home.css";
import { Dashboard } from "./../components/scripts/Dashboard";
import { QueueContent } from "../components/scripts/QueueContent";
import { ApiCall } from "./../utility/ApiCalls";
import Api_Call from "../ApiCall";
import axios from "axios";
import Loader from "react-loader-spinner";
import requests from "../utility/Requests";
import ErrorPage from "../components/Common/ErrorPage";

function UserHome() {
  const [activeTaskData, setActiveTaskData] = useState([]);
  const [taskData, setTaskData] = useState([]);
  const [displayReadyAssignedTable, setDisplayReadyAssignedTable] =
    useState(false);
  const [displayReadyActiveTable, setDisplayReadyActiveTable] = useState(false);
  const [displayReadyDashboard, setDisplayReadyDashboard] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [dashboardTasklist, setDashboardTasklist] = useState([]);
  const [taskQueue, setTaskQueue] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [taskBtn, setTaskBtn] = useState(true);
  const [completedListFlag, setCompletedListFlag] = useState(true);
  const [activeStyle, setActiveStyle] = useState({
    pending: false,
    inprogress: false,
    completed: false,
  });
  const [error, setError] = useState("");
  const [inprogressNo, setInProgressNo] = useState(0);
  const [completedNo, setCompletedNo] = useState(0);
  const [pendingNo, setPendingNo] = useState(0);

  useEffect(async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=1&module=intake");
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      setInProgressNo(data.body[0]["CountOfCases"]["InProgress"]);
      setPendingNo(data.body[0]["CountOfCases"]["Pending"]);
      setCompletedNo(data.body[0]["CountOfCases"]["Completed"]);
      setTaskQueue(data.body[0]["InProgress"]);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const taskQueueApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: true,
      inprogress: false,
      completed: false,
    });
    setLoading(true);
    setTaskBtn(true);
    setCompletedListFlag(false);
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=1&module=intake");
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      setPendingNo(data.body[0]["CountOfCases"]["Pending"]);
      setTaskQueue(data.body[0]["Pending"]);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const taskQueueInprogressApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: true,
      completed: false,
    });
    setLoading(true);
    setTaskBtn(false);
    setCompletedListFlag(false);
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=2&module=intake");
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      setInProgressNo(data.body[0]["CountOfCases"]["InProgress"]);
      setTaskQueue(data.body[0]["InProgress"]);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const taskQueueCompletedApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: false,
      completed: true,
    });
    setLoading(true);
    setTaskBtn(false);
    setCompletedListFlag(true);
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=3&module=intake");
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      setCompletedNo(data.body[0]["CountOfCases"]["Completed"]);
      setTaskQueue(data.body[0]["Completed"]);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <ErrorPage message={error.message} code={error.code} />;
  }

  return (
    <>
      <Box className="primary-title-new">
        <img src="img/heading-bg.png" />
        <Typography variant="h1">Utilization Management</Typography>
      </Box>
      <Dashboard
        type="agent"
        completedNo={completedNo}
        inprogressNo={inprogressNo}
        pendingNo={pendingNo}
        handlePending={taskQueueApi}
        handleInprogress={taskQueueInprogressApi}
        handleCompleted={taskQueueCompletedApi}
        activeStyle={activeStyle}
      ></Dashboard>
      {isLoading ? (
        <>
          <div className="content-container">
            <div className="div-loading">
              <Loader type="Puff" color="#00BFFF" height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <QueueContent
          type="agent"
          taskQueueData={taskQueue}
          taskBtn={taskBtn}
          completedListFlag={completedListFlag}
          activeStyle={activeStyle}
        ></QueueContent>
      )}
    </>
  );
}
export default UserHome;
